import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIAgentSuggestions } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { SUGGESTIONS_QUERY_KEY } from "../api/Suggestions";
const useDismissSuggestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (suggestionId) => AIAgentSuggestions.dismiss(suggestionId),
    onSuccess: () => {
      UserNotification.success("Suggestion dismissed.", "Tuning advisor");
      queryClient.invalidateQueries({ queryKey: SUGGESTIONS_QUERY_KEY });
    },
    onError: (e) => {
      UserNotification.error(`Dismiss failed: ${e.message}`, "Tuning advisor");
    }
  });
};
export default useDismissSuggestion;
